import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import type { TripItineraryData } from 'tripPlanner/api/types'

import { buildTripListRows, hasRenderableTripListContent } from './tripListRows'

export function useTripListRenderContent(itineraryData: TripItineraryData | undefined): boolean {
  const intl = useIntl()

  return useMemo(() => {
    const tripListRows = buildTripListRows(itineraryData, intl)
    return hasRenderableTripListContent(tripListRows, itineraryData?.stops)
  }, [intl, itineraryData])
}
